module.exports.types = {
    UINT : 0,
    INT : 1,
    BYTES : 2,
    STRING : 3,
    ARRAY : 4,
    MAP : 5,
    SEMANTIC : 6,
    SIMPLE : 7,
    FLOAT : 7
};

module.exports.additional = {
    FALSE : 20,
    TRUE : 21,
    NULL : 22,
    UNDEFINED : 23,
    SIMPLE : 24,
    HALF_PRECISION : 25,
    SINGLE_PRECISION : 26,
    DOUBLE_PRECISION : 27,
    BREAK : 31
};

module.exports.tokens = {
    ARRAY_START : 0,
    ARRAY_END : 1,
    MAP_START : 2,
    MAP_END : 3,
    STRING_START : 4,
    STRING_END : 5,
    VALUE : 6
};

module.exports.isStructStart = function(token) {
     switch (token) {
        case module.exports.tokens.ARRAY_START :
        case module.exports.tokens.MAP_START :
        case module.exports.tokens.STRING_START :
            return true;
        default :
            return false;
    }
};

module.exports.isStructEnd = function(token) {
    switch (token) {
        case module.exports.tokens.ARRAY_END :
        case module.exports.tokens.MAP_END :
        case module.exports.tokens.STRING_END :
            return true;
        default :
            return false;
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/cbor/consts.js
// module id = 188
// module chunks = 1